/* ============================================================================
   3D BUILDER  -  MOTOR AND MOTOR COVER

   Rules, in full:

       Motor       ->  motor visible, cover hidden
       Motor Cover ->  motor visible, cover visible  (the cover fits OVER it)

   The motor is never hidden. That is the point.

   ---------------------------------------------------------------------------
   THE NAME TRAP - read this before changing any pattern below

   three.js does not use GLTF node names as written. GLTFLoader runs them
   through PropertyBinding.sanitizeNodeName, which REPLACES EVERY SPACE WITH AN
   UNDERSCORE. So the mesh authored as

       FULL SUSPENSION Frame - Motor

   arrives in the scene as

       FULL_SUSPENSION_Frame_-_Motor

   The section already knows this - every place it matches a mesh does
   `o.name.replace(/_/g, ' ')` first, which is why its patterns are written
   with spaces. This file did not, and matched the raw name instead. The cover
   worked because `motorcover` contains no spaces and so survives sanitising
   unchanged; the motor never matched anything, which is exactly why it kept
   disappearing no matter what else was tried.

   Normalise first, then test. Always.
   ---------------------------------------------------------------------------

   WHY THE MOTOR HAS TO BE FORCED VISIBLE
   The section's swapping is one-of-N: choosing a value shows its meshes and
   hides every other value's. The motor is registered under the 'Surron' value,
   so picking 'Motor Cover' hides it. That is right for a seat or a battery,
   where two parts occupy the same space, and wrong for a cover, which goes on
   top of a motor rather than instead of one.

   WHY IT ENFORCES CONTINUOUSLY
   Setting visibility once after a click loses to anything that touches the
   scene afterwards. This holds both values instead, writing only when a mesh
   disagrees with what it should be, and pausing while the tab is hidden.
   ============================================================================ */
(function () {

  var COVER = /^motorcover$/i;
  var MOTOR = /FULL SUSPENSION Frame - Motor$/i;

  /* The one line this file got wrong for five attempts. */
  function readable(mesh) {
    return (mesh.name || '').replace(/_/g, ' ');
  }

  var cover = null;
  var motor = null;

  function wantsCover() {
    var el = document.querySelector('#pm-builder .pm-optval[data-prop="Motor"]');
    if (!el) return null;
    return el.textContent.trim() === 'Motor Cover';
  }

  function findMeshes() {
    var S = window.__pmScene;
    if (!S || !S.model) return;
    S.model.traverse(function (o) {
      if (!o.isMesh || !o.name) return;
      var name = readable(o);
      if (!cover && COVER.test(name)) cover = o;
      else if (!motor && MOTOR.test(name)) motor = o;
    });
  }

  function enforce() {
    if (document.hidden) return;

    if (!cover || !cover.parent || !motor || !motor.parent) findMeshes();

    /* Never hidden, whatever the section decided. */
    if (motor && motor.visible !== true) motor.visible = true;

    if (!cover) return;
    var want = wantsCover();
    if (want === null) return;

    if (cover.visible !== want) cover.visible = want;
  }

  window.setInterval(enforce, 250);

  /* Immediate response to a click, so the change is not up to 250ms late. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('.pm-sw')) return;
    window.setTimeout(enforce, 30);
  });

  /* Diagnosis from the console: __pmParts.status()
     `names` lists every mesh with 'motor' in it, as three.js actually named
     them - the fastest way to catch a pattern that no longer matches. */
  window.__pmParts = {
    enforce: enforce,
    status: function () {
      findMeshes();
      var names = [];
      var S = window.__pmScene;
      if (S && S.model) {
        S.model.traverse(function (o) {
          if (o.isMesh && /motor/i.test(o.name || '')) {
            names.push(o.name + '  (visible: ' + o.visible + ')');
          }
        });
      }
      return {
        sceneReady: !!(S && S.model),
        motorFound: !!motor,
        motorVisible: motor ? motor.visible : null,
        coverFound: !!cover,
        coverVisible: cover ? cover.visible : null,
        optionReadsAs: (function () {
          var el = document.querySelector('#pm-builder .pm-optval[data-prop="Motor"]');
          return el ? el.textContent.trim() : '(option not found)';
        })(),
        coverShouldShow: wantsCover(),
        names: names
      };
    }
  };
})();
